import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-document',
  templateUrl: './document.component.html',
  styleUrls: ['./document.component.scss']
})
export class DocumentComponent implements OnInit {

  @Input() document: any = {};
  @Input() document_uuid: string | null = null;
  constructor() { }

  ngOnInit(): void {
  }

}
